import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BookingForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/booking-app.css");
